import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { withRouter } from 'react-router'

import { ChevronThinLeft } from '../Icons'
import { StyledLink, IconContainer } from './styles'

class BackLink extends Component {

  render() {
    const { title, link, contained } = this.props

    return (
      <StyledLink contained={contained}>
        <Link to={link}>
        
          <IconContainer>
            <ChevronThinLeft size="" />
          </IconContainer>
        
          <span>{title}</span>

        </Link>
      </StyledLink>
    )
  }
}

export default withRouter(BackLink)


// WEBPACK FOOTER //
// ./src/components/BackLink/index.js